

// routes

import { useRoutes } from "react-router-dom";
import MainRoutes, { OtherRoutes } from "./MainRoutes";
import { AuthRoutes } from "./AuthRoutes";


export default function AllRoutes() {
    return useRoutes([MainRoutes,OtherRoutes,AuthRoutes]);
}
